import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { FlatTreeControl, NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener, MatTreeNestedDataSource } from '@angular/material/tree';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTree } from '@angular/material/tree';
import { Critere } from 'src/app/utils/interfaces/new/Critere';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { CritereService } from 'src/app/services/critere/critere.service';
import { environment } from 'src/environments/environment';

interface SelectFactor {
  doSelect: boolean;
  factorId: string;
}

@Component({
  selector: 'app-search-critere',
  templateUrl: './search-critere.fragment.html',
  styleUrls: [
    './search-critere.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class SearchCritereFragment implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  @Output() public closeEmitter = new EventEmitter();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeAddEditModal();
    }
  }

  untouchedCriteres: Critere[];
  criteresBodyTable: Paginated<Critere>;
  criteresColumnTable = [
    { title: 'Nom du critère', data: 'name' }
  ];

  addFactor: any;

  selectedCriteres: Critere[] = [];


  constructor(
    private _critere: CritereService
  ) { }


  async ngOnInit(): Promise<void> {
    this.criteresBodyTable = await this._critere.find();
    this.untouchedCriteres = this.criteresBodyTable.objects;
  }

  public closeAddEditModal(object?: any): void {
    if (object) {
      this.closeEmitter.emit(object);
    } else {
      this.closeEmitter.emit(null);
    }
  }

  onSearchCritere(event: any) {
    this.criteresBodyTable.objects = this.untouchedCriteres.filter(
      x => x.name.toLowerCase().includes(event.toLowerCase())
    );
  }

  sendCriteres() {
    this.closeAddEditModal(this.selectedCriteres);
  }

  public addRemoveFactor(event: any): void {
    if (this.selectedCriteres.indexOf(event, 0) > -1) {
      this._doSelectFactor({ doSelect: false, factorId: event.id });
      const index = this.selectedCriteres.indexOf(event, 0);
      if (index > -1) {
        this.selectedCriteres.splice(index, 1);
      }
    } else {
      this._doSelectFactor({ doSelect: true, factorId: event.id });
      this.selectedCriteres.push(event);
    }
  }

  private _doSelectFactor(factor: SelectFactor): void {
    if (this.criteresBodyTable && this.criteresBodyTable.objects) {
      const index = this.criteresBodyTable.objects.findIndex(p => p.id === factor.factorId);
      const factorDisplayTable = this.criteresBodyTable.objects.find(p => p.id === factor.factorId);

      if (factor.doSelect) {
        Object.defineProperty(factorDisplayTable, 'rowColor', { configurable: true, value: 'var(--primary)' });
        Object.defineProperty(factorDisplayTable, 'textColor', { configurable: true, value: 'var(--white)' });
      } else {
        Object.defineProperty(factorDisplayTable, 'rowColor', { configurable: true, value: 'transparent' });
        Object.defineProperty(factorDisplayTable, 'textColor', { configurable: true, value: 'var(--black)' });
      }

      this.criteresBodyTable.objects.splice(index, 1, factorDisplayTable);
    }
  }
}
